<template>
    <div class="modal-card">
        <header class="modal-card-head has-background-white">
            <h3 class="modal-card-title has-text-centered">
                {{ basicData.company_name }}
                <br/>
                <span class="subtitle">
                    {{ basicData.file_desc }}
                </span>
            </h3>
            <button class="delete" aria-label="Cerrar Modal" @click="$emit('close')" />
        </header>
        <section :class="['modal-card-body', {'no-padding': formatMode}]">
            <FormatExcelModal v-if="formatMode" 
                :company="basicData.companyId" :format-data="formatData" @close-format="closeFormat()" />
            <div class="container-files" v-else>
                <div v-if="tableData.data && tableData.data.length">
                    <span class="paginationbar">
                        <UploadsPagination @update-page="goPage" :page="tableData.page" :before="tableData.before"
                            :after="tableData.after" :data="tableData.data" />
                    </span>
                    <div class="mainTableDiv">
                        <table class="mainTableTable">
                            <tr v-for="row in tableData.data" :key="row.id" class="upload-row">
                                <td class="file_name">{{ row.filename }}</td>
                                <td class="file_type">{{ row.file_desc }}</td>
                                <td class="file_date">{{ formatDate(row.date) }}</td>
                                <td class="username">{{ row.username }}</td>
                                <td class="file_button">
                                    <div v-if="row.status == 'SUBIDO_EXITOSAMENTE'">
                                        <SimpleButton :buttonStyle="`linear-gradient(135deg, #f9f9fe, #f6f6fe)`"
                                            @click="openFormat(row)">
                                            <span v-if="row.has_translation == false">Sin</span>
                                            <span v-if="row.has_translation == true">Editar</span>
                                            Formato
                                        </SimpleButton>
                                    </div>
                                </td>
                                <td class="file_button">
                                    <div v-if="row.status == 'SUBIDO_EXITOSAMENTE'" class="nobreak">
                                        <SimpleButton :disabled="process_disabled" v-if="row.archived != true"
                                         :buttonStyle="`linear-gradient(45deg, #fafffa, #e9ffe9)`"
                                            @click="reprocess(row, true)">Aplicar archivo
                                        </SimpleButton>
                                        <span v-else> <!-- look, it does not work if the v-else is in the SimpleButton, dunno why -->
                                            <SimpleButton :disabled="process_disabled"
                                            :buttonStyle="`linear-gradient(45deg, #ffe9e9, #ffc0c0)`"
                                                @click="reprocess(row, false)">Retirar archivo
                                            </SimpleButton>
                                        </span>
                                        <span v-if="row.archived == true" class="formatSymbol">𐎄</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <span class="paginationbar">
                        <UploadsPagination @update-page="goPage" :page="tableData.page" :before="tableData.before"
                            :after="tableData.after" :data="tableData.data" />
                    </span>
                </div>
                <p v-else>No data available.</p>
            </div>
        </section>
        <footer :class="['modal-card-foot', 'bt-none', 'has-background-white', 'is-justify-content-flex-end', {'invisible': formatMode }]">
            <button v-if="!formatMode" class="button" @click="$emit('close')" aria-label="Cerrar Modal" role="button">
                Volver
            </button>
        </footer>
    </div>
</template> 


<script>
import { getUploadedFiles, toggleFile } from "@/api/carteraAnalista";
import FormatExcelModal from "@/components/modals/FormatExcelModal";
import UploadsPagination from "@/components/modals/UploadsPagination";
import SimpleButton from "./SimpleButton";

export default {
    name: "CompanyUploads",
    components: {
        UploadsPagination,
        FormatExcelModal,
        SimpleButton,
    },
    data() {
        return {
            formatMode: false,
            formatData: null,
            loading: null,
            tableData: {
                loading: true,
                page: 0,
                before: false,
                after: false,
                data: null,
            },
            process_disabled: false,
        };
    },
    mounted() {
        getUploadedFiles(this.basicData.companyId, this.basicData.file_id, this.tableData.page).then((response) => {
            const data = response.data;
            this.tableData.loading = false;
            this.tableData.data = data.files;
            this.tableData.before = data.before;
            this.tableData.after = data.after;
            this.tableData.page = data.page;
            this.tableData.has_translation = data.has_translation;
        })
    },
    props: {
        basicData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        reprocess(obj, toggle) {
            this.process_disabled = true;
            try {
                toggleFile(obj.id, toggle, this.basicData.companyId).then(() => {
                    this.goPage(this.tableData.page, true);
                });
            } catch(err) {
                console.log('error:', err);
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year} ${month} ${day} ${hours}:${minutes}:${seconds}`;
        },
        goPage(page, reEnable=false) {
            getUploadedFiles(this.basicData.companyId, this.basicData.file_id, page).then((response) => {
                const data = response.data;
                this.tableData.loading = false;
                this.tableData.data = data.files;
                this.tableData.before = data.before;
                this.tableData.after = data.after;
                this.tableData.page = data.page;
                this.tableData.has_translation = data.has_translation;
                if (reEnable) {
                    this.process_disabled = false;
                }
            })
        },
        openFormat(row) {
            this.formatData = row
            this.formatMode = true;
        },
        closeFormat() {
            this.formatMode = false;
            this.goPage(this.tableData.page, true);
        }
    }

};
</script>
<style scoped>
.modal-card {
    width: 100%;
    height: 100%;
}

.username {
    font-size: 0.65em;
    padding-left: 1em;
}

.file_date {
    font-size: 0.65em;
    padding-left: 1em;
    padding-top: 0.3em;
}

.file_name {
    font-weight: bold;
    font-size: 0.9em;
}

.file_type {
    padding-left: 1em;
    font-size: 0.8em;
}

.file_button {
    padding-left: 1em;
}

.container-files {
    height: 20em;
}

.paginationbar {
    width: 50%;
    margin: auto;
    text-align: center;
}

.mainTable {
    width: 100%;
    height: 100%;
    min-height: 18em;
    background-image: linear-gradient(135deg, #fefefe, #fafafa);
    border-radius: 12px;
}

.mainTableDiv {
    width: 100%;
    height: 100%;
    background-image: linear-gradient(135deg, #fefefe, #fafafa);
    border-radius: 2px;
    min-height: 17em;
}

.mainTableTable {
    width: 100%;
}

.formatSymbol {
    font-weight: 100;
    font-size: 1em;
    position: relative;
    top: 2px;
    left: 10px;
}

.upload-row {
    height: 1.5em;
}
.invisible {
    height: 0 !important;
    display: none;
}
.no-padding {
    padding: 0px !important;
}
.nobreak {
    white-space: nowrap;
}
</style>
<style>
.animation-content {
    width: 95%;
    height: 95%;
}
</style>